<template>
  <div class="relative mx-1 inline-flex icon-sm items-center rounded-full bg-recommendation-base align-text-top" />
</template>
